import PropTypes from 'prop-types';
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import SiteNavItem from './SiteNavItem';

import styles from './SiteNav-style.scss';

export function SiteNav(props) {
    return (
        <div className={styles.wrapper}>
            <div className={styles.items}>
                {(get(props.navigation, 'modules') || []).map(module => {
                    if (!module.visible) {
                        return null;
                    }
                    return (
                        <SiteNavItem
                            {...module}
                            key={module.serviceId}
                            showFullWidthNav={props.viewer && props.viewer.showFullWidthNav}
                            navigationModule={module}
                        />
                    );
                })}
            </div>
        </div>
    );
}

SiteNav.propTypes = {
    navigation: PropTypes.object,
    viewer: PropTypes.object,
};

export default createFragmentContainer(SiteNav, {
    viewer: graphql`
        fragment SiteNav_viewer on Viewer {
            showFullWidthNav: isEnabled(key: "showFullWidthNav")
        }
    `,
    navigation: graphql`
        fragment SiteNav_navigation on Navigation {
            modules {
                serviceId
                name
                url
                visible
                isHighlighted
                ...SiteNavItem_navigationModule
                items {
                    serviceId
                    name
                    type
                    column
                    items {
                        serviceId
                        name
                        url
                        visible
                    }
                }
            }
        }
    `,
});
